import { gql, TypedDocumentNode } from "@apollo/client";

import {
  GetBlacklistElementByIdQuery,
  GetBlacklistElementByIdQueryVariables,
} from "src/graphql/anti-fraud/__generated__/graphql";
import { blacklistElementFragment } from "src/graphql/anti-fraud/fragments/BlacklistElementFragment";
import { useFetchQuery } from "src/graphql/utils/useFetchQuery.ts";

export const getBlacklistElementByIdQuery = gql`
  query GetBlacklistElementById($id: ID!) {
    blacklistElement(id: $id) {
      ...BlacklistElement
    }
  }

  ${blacklistElementFragment}
` as TypedDocumentNode<GetBlacklistElementByIdQuery, GetBlacklistElementByIdQueryVariables>;

export const useGetBlacklistElementById = (options: { id: string | undefined }) => {
  return useFetchQuery(getBlacklistElementByIdQuery, {
    toData: (data) => data?.blacklistElement,
    isEmpty: (data) => !data?.blacklistElement,
    uiErrors: {
      fetchError: "FETCH-LIST-ELEMENTS-ERROR",
    },
    queryOptions: {
      variables: { id: options.id ?? "" },
      skip: !options.id,
    },
  });
};
